import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { MSGraphRoot, NovaChatContainer, NovaProvider } from '@newfront-insurance/nova-core/v2';
import { useProvider } from '@newfront-insurance/react-provision';
import type { JSX } from 'react';

import { AuthProvider } from '@/client/providers/auth';

export function NovaChatFeature(): JSX.Element | null {
  const msGraphEnabled = useFeatureFlag('nova-tools-graph-api', false);
  const { userDetails } = useProvider(AuthProvider);
  const { uuid: userUuid, scopes } = userDetails ?? {};

  if (!userUuid) {
    return null;
  }

  return (
    <MSGraphRoot enabled={msGraphEnabled}>
      <NovaProvider userUuid={userUuid} scopes={scopes} authProvider={AuthProvider} isStandaloneMode>
        <NovaChatContainer />
      </NovaProvider>
    </MSGraphRoot>
  );
}
